import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import i18n from "@emoji-mart/data/i18n/fr.json";
/** Local data and local French strings avoid the library's optional CDN fetch. */
export default function ReactionPicker({
  onSelect,
  onClose,
}: {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}) {
  const root = useRef<HTMLDivElement>(null),
    close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const containFocus = (e: FocusEvent) => {
      if (root.current && !root.current.contains(e.target as Node))
        root.current
          .querySelector<HTMLButtonElement>(".chat-emoji-close")
          ?.focus();
    };
    root.current
      ?.querySelector<HTMLButtonElement>(".chat-emoji-close")
      ?.focus();
    document.addEventListener("focusin", containFocus);
    const outside = (e: PointerEvent) => {
      if (root.current && !e.composedPath().includes(root.current))
        close.current();
    };
    const escape = (e: globalThis.KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        close.current();
      }
    };
    document.addEventListener("pointerdown", outside);
    document.addEventListener("keydown", escape, true);
    return () => {
      document.removeEventListener("focusin", containFocus);
      document.removeEventListener("pointerdown", outside);
      document.removeEventListener("keydown", escape, true);
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return createPortal(
    <div className="chat-emoji-overlay">
      <div
        ref={root}
        className="chat-emoji-popover"
        role="dialog"
        aria-label="Choisir un emoji"
        aria-modal="true"
      >
        <button className="chat-emoji-close" type="button" onClick={onClose}>
          Fermer
        </button>
        <Picker
          data={data}
          i18n={i18n}
          set="native"
          locale="fr"
          theme="light"
          autoFocus
          dynamicWidth
          previewPosition="none"
          maxFrequentRows={1}
          onEmojiSelect={(emoji: { native: string }) => onSelect(emoji.native)}
        />
      </div>
    </div>,
    document.body
  );
}
